var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgQuest = function SvgQuest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00082 1V1.38C7.17082 1.05 6.28082 0.88 5.39082 0.88C3.97082 0.88 2.55082 1.31 1.34082 2.17C0.830822 2.53 0.770822 3.26 1.21082 3.7L3.78082 6.27H4.89082V7.38C5.75082 8.24 6.87082 8.69 8.00082 8.74V11H6.00082C5.45082 11 5.00082 11.45 5.00082 12V14C5.00082 15.1 5.90082 16 7.00082 16H17.0008C18.6608 16 20.0008 14.66 20.0008 13V1C20.0008 0.45 19.5508 0 19.0008 0H9.00082C8.45082 0 8.00082 0.45 8.00082 1ZM6.89082 6.41V4.26H4.61082L3.57082 3.22C4.14082 3 4.76082 2.88 5.39082 2.88C6.73082 2.88 7.98082 3.4 8.93082 4.34L10.3408 5.75L10.1408 5.95C9.63082 6.46 8.95082 6.75 8.22082 6.75C7.75082 6.75 7.29082 6.63 6.89082 6.41ZM18.0008 13C18.0008 13.55 17.5508 14 17.0008 14C16.4508 14 16.0008 13.55 16.0008 13V12C16.0008 11.45 15.5508 11 15.0008 11H10.0008V8.41C10.5708 8.18 11.1008 7.84 11.5608 7.38L11.7608 7.18L14.5908 10H16.0008V8.59L10.0008 2.62V2H18.0008V13Z",
    fill: "url(#paint0_linear_14554_10644)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14554_10644",
    x1: 0.916016,
    y1: 0,
    x2: 21.6276,
    y2: 1.04731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846071,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE27B"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgQuest);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/quest.f4aa781a1f5e0c9fbf99ee03e9934dc3.svg";